export default (data, schema) => {
  return Object.keys(data).reduce((newData, key) => {
    var _schema$properties, _schema$properties$ke;
    // Read-only adapter
    if ((_schema$properties = schema.properties) !== null && _schema$properties !== void 0 && (_schema$properties$ke = _schema$properties[key]) !== null && _schema$properties$ke !== void 0 && _schema$properties$ke.readOnly) return newData;
    if (data[key] === undefined) newData[key] = null;else newData[key] = data[key];
    return newData;
  }, {});
};